<template>
    <div class="employee-tab-inner">           

        <b-card no-body class="border-0 ">
            <b-tabs pills card vertical content-class=" border rounded border-2 col-md-9" nav-class=" pt-0" nav-wrapper-class="col-md-3" disabled-nav-item-class="p-0 m-0">
                
                <template v-slot:tabs-start>
                    <b-nav-item disabled href="#" class="trz-avater mb-5" >
                        <b-avatar class="p-0 m-0" variant="light" rounded button  size="100%" :src="avatarsrc"></b-avatar>
                    </b-nav-item>
                </template>
                
                <b-tab v-for="(profile_data , index) in fdata" v-bind:key="profile_data.index">
                    <template v-slot:title>
                        {{index}}
                    </template>
                                        
                    <div class="clearfix row border-bottom py-2" v-for="(details_data , title_data) in profile_data" v-bind:k="profile_data.index">
                        <div class="col-sm-4 text-uppercase font-weight-bold">
                            {{title_data}}
                        </div>
                        <div class="col-sm-8 ">
                            <div v-if="index == 'Uploaded Files'">
                                <b-link :href="details_data" target="_blank"><b-icon icon="download" scale="2"></b-icon></b-link>
                            </div>                            
                            <div v-else>{{details_data}}</div> 
                        </div>
                    </div>

                </b-tab>

                
            </b-tabs>
        </b-card>            
        
    </div>
</template>
<style scoped>
    .trz-avater .disabled{ padding:0px !important; margin-top: -10px !important;}
</style>
<script>
    
    export default{
        
        mounted() {
            //console.log('login form info started..');               
        },
        components: {
            
        },
        data(){            
            
            return {
                                   
                fdata: [],
                avatarsrc : '',
            }
        },
        methods:{
            
            getEmployee: function(){
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/profile')
                    .then(function (response) {
                        
                        //alert(response.data.Avatar);                          
                        this.avatarsrc = response.data.Avatar;
                        this.fdata = response.data.profile;                 

                    }.bind(this));
            },

        },
        created: function(){            
            this.getEmployee();
        }
    }
</script>
